// extracted by mini-css-extract-plugin
module.exports = {"container":"Speaker_Image_container__2B26I","placeholder":"Speaker_Image_placeholder__1iuV8"};